"use client";

import { toast } from "@ui/components/toast";
import { useState } from "react";

/**
 * Copies `value` to the clipboard: `copied` is true for 2 s after, and a refused
 * clipboard says so in a toast. `onCopied` runs either way (the value can still be
 * copied by hand).
 */
export function useCopy(value: string, onCopied?: () => void) {
	const [copied, setCopied] = useState(false);
	const copy = async () => {
		try {
			await navigator.clipboard.writeText(value);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch {
			toast.add({
				type: "error",
				title: "Couldn't copy",
				description: "Select the text and copy it by hand.",
			});
		}
		onCopied?.();
	};
	return { copied, copy };
}
